
import { Route, RouteObject } from 'react-router-dom';
import SelfServicePage from './SelfServicePage';


export interface cxSelfServiceRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: cxSelfServiceRoute[];
}

export const cxSelfServiceRoutes: cxSelfServiceRoute[] = [
  {
      path: 'cx/selfService',
      element: <SelfServicePage />,
    },
   
];
